export default {
  // common
  ok: 'ОК',
  cancel: 'Отмена',
  send: 'Отправить',
  // time
  timeJustNow: 'Только что',
  timeMinutesAgo: '{n} мин назад',
  timeHoursAgo: '{n} ч назад',
  timeYesterday: 'Вчера',
  // chat toolbar titles
  chatEmotion: 'Эмодзи',
  chatSendImage: 'Отправить изображение',
  chatSendFile: 'Отправить файл',
  chatReceipt: 'Сообщение с подтверждением',
  chatSendVoice: 'Отправить голосовое',
  chatGroupInfo: 'Информация о группе',
  // chat area
  chatSomeoneAtMe: 'Меня упомянули',
  chatNewMessages: '{n} новых сообщений',
  chatBackToBottom: 'Вниз',
  chatReceiptPrefix: '[Подтверждение] ',
  // message actions / tips
  chatNoMoreMessages: 'Больше сообщений нет',
  chatDeleteConfirm: 'Удалить это сообщение?',
  chatDeleteTitle: 'Удалить сообщение',
  chatRecallConfirm: 'Отозвать это сообщение?',
  chatRecallTitle: 'Отозвать сообщение',
  chatRecalled: 'Сообщение отозвано',
  chatLocateFail: 'Не удалось найти исходное сообщение',
  chatResendUnsupported: 'Это сообщение не поддерживает автоматическую повторную отправку. Отправьте его вручную.',
  // input disabled tips
  chatGroupDissolved: 'Группа была распущена',
  chatGroupQuit: 'Вы больше не в этой группе',
  chatGroupBanned: 'Группа заблокирована',
  chatUserBanned: 'Этот аккаунт заблокирован',
  chatBanReason: ', причина: ',
  // message status / readed
  msgReaded: 'Прочитано',
  msgUnread: 'Не прочитано',
  msgAllReaded: 'Все прочитали',
  msgSomeReaded: 'Прочитали {n}',
  msgSending: 'Отправка',
  msgSendFail: 'Ошибка отправки',
  msgRecall: 'Позвонить снова',
  msgMenuDelete: 'Удалить',
  msgMenuRecall: 'Отозвать',
  // voice record
  recordTitle: 'Запись голоса',
  recordDuration: 'Длительность',
  recordStart: 'Начать',
  recordPause: 'Пауза',
  recordResume: 'Продолжить',
  recordStop: 'Стоп',
  recordPlay: 'Воспроизвести',
  recordStopPlay: 'Остановить воспроизведение',
  recordRestart: 'Записать заново',
  recordSend: 'Отправить сейчас',
  recordStateReady: 'Не начато',
  recordStateRunning: 'Запись...',
  recordStatePaused: 'Запись приостановлена',
  recordStateStopped: 'Запись остановлена',
  msgReadedTab: 'Прочитано ({n})',
  msgUnreadTab: 'Не прочитано ({n})',
  // language
  langLabel: 'Язык',
  langZh: '中文',
  langEn: 'English'
}
